// SavedItems.js
import React from "react";
export default function SavedItems({ items }) {
  if (!items.length) {
    return (
      <div className="panel p-8 text-center">
        <h2 className="text-3xl mb-3">Saved Items</h2>
        <p className="text-[var(--muted)]">You have no saved items yet.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-3xl mb-6">Saved Items</h2>
      <ul className="grid sm:grid-cols-2 gap-4">
        {items.map((item, idx) => (
          <li key={idx} className="panel p-4">
            <p className="font-semibold mb-1">{item.name || "Saved Product"}</p>
            <p className="text-sm text-[var(--muted)]">{item.id || item.product_id}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
